@if (loadingAccessTemplates) {
  <div>
    <h3 class="panel-title"><i class="fa-solid fa-spinner fa-spin"></i> Loading updated access templates...</h3>
  </div>
} @else {
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Let's get you updated.</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="onCancel()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    @if (applicationType === 'aws') {
      <div class="modal-subtitle">
        We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
        CloudFormation stacks that grant {{ uiService.productName }} limited access to your AWS environment.
      </div>
      <aws-account-access-view
        class="margin-top"
        [state]="sourceAccessService.state"
        [stackName]="sourceAccessService.stack"
        [accessType]="Scope.SOURCE"
        [templateUrl]="sourceAccessTemplate"
        [awsAccountId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </aws-account-access-view>
      <aws-account-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [stackName]="targetAccessService.stack"
        [accessType]="Scope.TARGET"
        [templateUrl]="targetAccessTemplate"
        [awsAccountId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </aws-account-access-view>
      @if (stackSetsEnabled) {
        <stacksets-instructions
          class="margin-top"
          [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
          [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
          [sourceTemplateBucket]="sourceTemplateBucket"
          [sourceTemplateKey]="sourceTemplateKey"
          [targetTemplateBucket]="targetTemplateBucket"
          [targetTemplateKey]="targetTemplateKey"
          [sourceAccountId]="sourceAccountId"
          [sourceRegion]="sourceRegion"
          [targetAccountId]="targetAccountId"
          [targetRegion]="targetRegion"
          [sourceStackName]="sourceAccessService?.stack"
          [targetStackName]="targetAccessService?.stack"
          [sourceManagedByStackSet]="sourceAccessService?.managedByStackSet"
          [targetManagedByStackSet]="targetAccessService?.managedByStackSet"
          [sourceAccessState]="sourceAccessService?.state"
          [targetAccessState]="targetAccessService?.state"
          [testingSource]="isTestingSourceAccess"
          [testingTarget]="isTestingTargetAccess"
          [arpioAccountId]="accountId"
          [regenerationJobId]="regenerationJobId"
          (testAccess)="onTestAccess($event)"
        ></stacksets-instructions>
      }
    }
    @if (applicationType === 'azure') {
      <div class="modal-subtitle">
        We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
        Deployment Stacks that grant {{ uiService.productName }} limited access to your Azure environment.
      </div>
      <azure-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [accessType]="Scope.TARGET"
        [installCommand]="targetInstallCommand"
        [subscriptionId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </azure-access-view>
      <azure-access-view
        class="margin-top"
        [state]="sourceAccessService.state"
        [accessType]="Scope.SOURCE"
        [installCommand]="sourceInstallCommand"
        [subscriptionId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </azure-access-view>
    }
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="onCancel()">CANCEL</button>
      <button type="button" class="arpio-button" [disabled]="!accessChecksComplete" (click)="onFinish()">FINISH</button>
    </div>
  </div>
}
